/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_CourtsInputs */

const th_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนาม`)
};

const en_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Courts`)
};

const ja_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コート`)
};

const zh_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球场`)
};

const es_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pistas`)
};

const pt_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadras`)
};

const id_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lapangan`)
};

const fr_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terrains`)
};

const tl_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga court`)
};

const vi_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sân`)
};

const ko_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코트`)
};

const de_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Felder`)
};

const ru_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Площадки`)
};

const tr_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sahalar`)
};

const it_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campi`)
};

const pl_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boiska`)
};

const uk_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Майданчики`)
};

const hi_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोर्ट`)
};

const ar_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الملاعب`)
};

const ms_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelanggang`)
};

const bn_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোর্ট`)
};

const zh_tw2_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球場`)
};

const zh_hk2_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球場`)
};

const ur_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کورٹ`)
};

const fa_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زمین‌ها`)
};

const sw_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viwanja`)
};

const nl_tab_courts = /** @type {(inputs: Tab_CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velden`)
};

/**
* | output |
* | --- |
* | "Courts" |
*
* @param {Tab_CourtsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_courts = /** @type {((inputs?: Tab_CourtsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_CourtsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_tab_courts(inputs)
	if (locale === "ja") return ja_tab_courts(inputs)
	if (locale === "zh") return zh_tab_courts(inputs)
	if (locale === "es") return es_tab_courts(inputs)
	if (locale === "pt") return pt_tab_courts(inputs)
	if (locale === "id") return id_tab_courts(inputs)
	if (locale === "fr") return fr_tab_courts(inputs)
	if (locale === "tl") return tl_tab_courts(inputs)
	if (locale === "vi") return vi_tab_courts(inputs)
	if (locale === "ko") return ko_tab_courts(inputs)
	if (locale === "de") return de_tab_courts(inputs)
	if (locale === "ru") return ru_tab_courts(inputs)
	if (locale === "tr") return tr_tab_courts(inputs)
	if (locale === "it") return it_tab_courts(inputs)
	if (locale === "pl") return pl_tab_courts(inputs)
	if (locale === "uk") return uk_tab_courts(inputs)
	if (locale === "hi") return hi_tab_courts(inputs)
	if (locale === "ar") return ar_tab_courts(inputs)
	if (locale === "ms") return ms_tab_courts(inputs)
	if (locale === "bn") return bn_tab_courts(inputs)
	if (locale === "zh-TW") return zh_tw2_tab_courts(inputs)
	if (locale === "zh-HK") return zh_hk2_tab_courts(inputs)
	if (locale === "ur") return ur_tab_courts(inputs)
	if (locale === "fa") return fa_tab_courts(inputs)
	if (locale === "sw") return sw_tab_courts(inputs)
	if (locale === "nl") return nl_tab_courts(inputs)
	return en_tab_courts(inputs)
});